module.exports = __webpack_public_path__ + "static/sportenExtra-1ddca7ff907db7e083b5ba20ea705cd1.svg";